var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoldCup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10679_1344)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.7706 24.4775H18.3293V33.0861H20.7706V24.4775Z",
    fill: "url(#paint0_linear_10679_1344)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.0677 6.3042H1.53857C1.53857 12.1428 1.98633 15.5013 10.3051 15.5013",
    stroke: "#FFDD66",
    strokeWidth: 3.07692
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5594 13.9512C30.5594 20.058 25.609 25.0085 19.5022 25.0085C13.3955 25.0085 8.44507 20.058 8.44507 13.9512C8.44507 7.84452 13.3955 2.89404 19.5022 2.89404C25.609 2.89404 30.5594 7.84452 30.5594 13.9512Z",
    fill: "#FFDD66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.502 32.6558C14.9934 32.6558 11.3384 33.9744 11.3384 35.601H27.6659C27.6659 33.9744 24.0108 32.6558 19.502 32.6558Z",
    fill: "#FFDD66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.44507 0.769043H30.5594V13.4346H8.44507V0.769043Z",
    fill: "#FFDD66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6659 36.1693H11.3384V35.5493H27.6659V36.1693Z",
    fill: "#FFDD66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2467 6.3042H37.7757C37.7757 12.1428 37.328 15.5013 29.0093 15.5013",
    stroke: "#DE9300",
    strokeWidth: 3.07692
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5589 13.9513C30.5589 20.058 25.6085 25.0084 19.5017 25.0084C19.5017 25.0084 19.5017 20.058 19.5017 13.9513C19.5017 7.84452 19.5017 2.89404 19.5017 2.89404C25.6085 2.89404 30.5589 7.84452 30.5589 13.9513Z",
    fill: "url(#paint1_linear_10679_1344)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5017 32.6558C19.5017 32.6558 19.5017 33.9744 19.5017 35.6008H27.6654C27.6654 33.9744 24.0105 32.6558 19.5017 32.6558Z",
    fill: "url(#paint2_linear_10679_1344)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5017 0.77002H30.5589V13.4348H19.5017V0.77002Z",
    fill: "url(#paint3_linear_10679_1344)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6655 36.1692H19.5018C19.5018 36.1692 19.4835 35.7906 19.5018 35.5491C19.7432 32.3702 27.6655 35.5491 27.6655 35.5491V36.1692Z",
    fill: "url(#paint4_linear_10679_1344)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.719 19.338C23.3735 19.338 26.336 16.3755 26.336 12.721C26.336 9.06653 23.3735 6.104 19.719 6.104C16.0646 6.104 13.1021 9.06653 13.1021 12.721C13.1021 16.3755 16.0646 19.338 19.719 19.338Z",
    fill: "#FFDD66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7057 7.19922L21.3822 10.5522L24.7351 10.9713L22.4327 13.553L23.0587 17.2581L19.7057 15.5816L16.3528 17.2581L16.9842 13.553L14.6763 10.9713L18.0293 10.5522L19.7057 7.19922Z",
    fill: "#FFF4BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3939 6.85505L19.7059 5.479L19.0177 6.85505L17.5254 9.83976L14.581 10.2078L13.125 10.3898L14.1029 11.4838L16.1637 13.7891L15.5946 17.1287L15.3396 18.6245L16.697 17.9459L19.7059 16.4415L22.7148 17.9459L24.0696 18.6233L23.8173 17.1298L23.253 13.7891L25.3093 11.4831L26.2845 10.3896L24.8306 10.2078L21.8862 9.83976L20.3939 6.85505Z",
    stroke: "#C98500",
    strokeOpacity: 0.7,
    strokeWidth: 1.53846
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7693 36.1538H7.69238V39.2307H30.7693V36.1538Z",
    fill: "#DE9300"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10679_1344",
    x1: 19.55,
    y1: 24.4775,
    x2: 19.55,
    y2: 33.086,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C07F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DE9300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10679_1344",
    x1: 30.4828,
    y1: 11.9204,
    x2: 19.3976,
    y2: 11.9204,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE9300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBC11"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_10679_1344",
    x1: 30.4828,
    y1: 11.9206,
    x2: 19.3976,
    y2: 11.9206,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE9300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBC11"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_10679_1344",
    x1: 30.4828,
    y1: 11.9206,
    x2: 19.3976,
    y2: 11.9206,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE9300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBC11"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_10679_1344",
    x1: 30.4829,
    y1: 11.9205,
    x2: 19.3976,
    y2: 11.9205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE9300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBC11"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10679_1344"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoldCup);
export default __webpack_public_path__ + "static/media/gold-cup.fc2781c983b68abb5fd7238e9fc58123.svg";
export { ForwardRef as ReactComponent };